:host {
  display: block;
}

.toastWrapper {
  background-color: var(--toast-color-surface-default);
  color: var(--toast-color-text-default);
  fill: var(--toast-color-text-default);
  box-shadow: 0px 10px 50px 10px rgba(0, 0, 0, 0.17);

  &.show {
    visibility: visible;
  }

  &.bottom-left {
    left: 20px;
    max-width: calc(100vw - 40px);
    bottom: var(--animation-value);
    animation: fadeinFromBottom 0.5s;
    -webkit-animation: fadeinFromBottom 0.5s;
  }

  &.bottom-right {
    right: 20px;
    max-width: calc(100vw - 40px);
    bottom: var(--animation-value);
    animation: fadeinFromBottom 0.5s;
    -webkit-animation: fadeinFromBottom 0.5s;
  }

  &.bottom-center {
    bottom: var(--animation-value);
    animation: fadeinFromBottom 0.5s;
    -webkit-animation: fadeinFromBottom 0.5s;
    &.desktop_tablet {
      left: calc(50% - var(--width) / 2);
      max-width: calc(100vw - 40px);
    }
    &.mobile {
      left: 20px;
    }
  }

  &.top-left {
    left: 20px;
    top: var(--animation-value);
    max-width: calc(100vw - 40px);
    animation: fadeinFromTop 0.5s;
    -webkit-animation: fadeinFromTop 0.5s;
  }

  &.top-right {
    right: 20px;
    top: var(--animation-value);
    max-width: calc(100vw - 40px);
    animation: fadeinFromTop 0.5s;
    -webkit-animation: fadeinFromTop 0.5s;
  }

  &.top-center {
    left: calc(50% - var(--width) / 2);
    top: var(--animation-value);
    animation: fadeinFromTop 0.5s;
    -webkit-animation: fadeinFromTop 0.5s;
  }

  &.error {
    background-color: var(--toast-color-surface-error);
  }

  &.success {
    background-color: var(--toast-color-surface-success);
  }

  &.warning {
    background-color: var(--toast-color-surface-warning);
    color: var(--toast-color-text-warning);
    fill: var(--toast-color-text-warning);
  }
}

@-webkit-keyframes fadeinFromBottom {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: var(--animation-value);
    opacity: 1;
  }
}

@keyframes fadeinFromBottom {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: var(--animation-value);
    opacity: 1;
  }
}

@-webkit-keyframes fadeinFromTop {
  from {
    top: 0;
    opacity: 0;
  }
  to {
    top: var(--animation-value);
    opacity: 1;
  }
}

@keyframes fadeinFromTop {
  from {
    top: 0;
    opacity: 0;
  }
  to {
    top: var(--animation-value);
    opacity: 1;
  }
}

.icon-subinfo {
  height: 24px;
  width: 24px;
  margin-top: 4px;
  margin-right: 4px;
}

.button-undo {
  background: none;
  cursor: pointer;
  font-size: 14px;
}

.sub-content {
  padding-left: 9px;
}
